import React from 'react';
import { useIsPublicOrgMissingInfo } from '../../hooks/useIsPublicOrgMissingInfo';
import Alert from '../v2BaseComponents/Alert';
import { getIntl } from '../../utils/intl';
import { contentStackSpacing } from '../v2BaseComponents/Stack';

const intl = getIntl('maybe-public-org-missing-info-alert', {
    header: 'Organization Profile Not Complete',
    message:
        'Be sure to add a logo so that the invitation email and registration screens will be branded.\nClick on the organization in the top right to set.',
});

export type MaybePublicOrgMissingInfoAlertOwnProps = {};

export type MaybePublicOrgMissingInfoAlertProps = MaybePublicOrgMissingInfoAlertOwnProps;

const MaybePublicOrgMissingInfoAlert: React.FC<MaybePublicOrgMissingInfoAlertProps> = () => {
    const { isMissingInfo } = useIsPublicOrgMissingInfo();

    if (isMissingInfo !== true) return null;

    return (
        <Alert
            type="warning"
            title={intl('header')}
            message={intl('message')}
            testID="public-org-missing-info-alert"
            style={{ paddingBottom: contentStackSpacing }}
        />
    );
};

export default React.memo(MaybePublicOrgMissingInfoAlert);
